module.exports = __webpack_public_path__ + "static/media/charm_circle-tick.d9447c14.svg";